module.exports = __webpack_public_path__ + "a30ab08352078cf7aa42cc9753ca2995.png";